/*
 * @Author: cn1994
 * @Date: 2023-08-06 14:01:10
 * @LastEditors: cn1994
 * @LastEditTime: 2024-10-09 14:15:01
 * @Description: file content
 */
/*
 * @Author: cn1994
 * @Date: 2023-08-06 14:01:10
 * @LastEditors: cn1994
 * @LastEditTime: 2023-08-08 16:14:18
 * @Description: file content
 */
import request from '@/common/request.js'
import { useBaseStore } from "@/stores/base";
const baseStore = useBaseStore();

// 获取校区列表 新 - https://kf.51tyty.com/doc/web/#/282/12887
export const getCampusList = (params) => {
  return request({
    url: `BUSINESS/business/getCampusList`,
    method: 'get',
    params
  })
}

// 获取校区基础账号 - 新 - https://kf.51tyty.com/doc/web/#/282/12891
export const getCampusAccount = (params) => {
  return request({
    url: `BUSINESS/business/getAdminAccount`,
    method: 'get',
    params
  })
}

// 获取科目列表 -新 https://kf.51tyty.com/doc/web/#/282/12889
export const getSubjectList = (params) => {
  return request({
    url: `BUSINESS/business/getSubjectList`,
    method: 'get',
    params
  })
}

// 获取所有科目列表 - 新 - https://kf.51tyty.com/doc/web/#/282/12888
export const getAllSubjectList = (params) => {
  return request({
    url: `BUSINESS/business/getDcpSubjectList`,
    method: 'get',
    params
  })
}

// 开通科目（直接开通）- https://kf.51tyty.com/doc/web/#/282/12976
export const directlyCreateSubject = (data) => {
  return request({
    url: `BUSINESS/business/directlyCreateSubject`,
    method: 'post',
    data
  })
}

// 开通科目（付款界面）- https://kf.51tyty.com/doc/web/#/282/12974
export const createSubject = (data) => {
  return request({
    url: `BUSINESS/business/createSubject`,
    method: 'post',
    data
  })
}

// 删除科目
export const deleteSubject = (params) => {
  return request({
    url: `OSS/index.php?g=Headmaster&m=subject&a=del`,
    method: 'get',
    params
  })
}

// 开通校区（直接开通） - https://kf.51tyty.com/doc/web/#/282/12990
export const directlyCreateCampus = (data) => {
  return request({
    url: `BUSINESS/business/directlyCreateCampus`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data
  })
}

// 开通校区（付款界面） - https://kf.51tyty.com/doc/web/#/282/12989
export const createCampus = (data) => {
  return request({
    url: `BUSINESS/business/createCampus`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data
  })
}

// 获取主校信息 - 新 - https://kf.51tyty.com/doc/web/#/282/12892
export const getBusinessInfo = (params) => {
  return request({
    url: `BUSINESS/business/getBusinessInfo`,
    method: 'get',
    params
  })
}

// 编辑校区
export const editCampus = (data) => {
  return request({
    url: `BUSINESS/business/editCampus`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data
  })
}

// 编辑科目昵称
export const editSubjectNickname = (data) => {
  return request({
    url: `BUSINESS/business/editSubject`,
    method: 'post',
    data
  })
}

// 删除校区
export const deleteCampus = (params) => {
  return request({
    url: `OSS/index.php?g=Headmaster&m=Subject&a=delBranch`,
    method: 'get',
    params
  })
}

// 切换校区 - 新 - https://kf.51tyty.com/doc/web/#/282/12886
export const switchInst = (data) => {
  return request({
    url: `BUSINESS/business/switchInst`,
    method: 'post',
    data
  })
}

// 获取学科试用状态  - 新 - https://kf.51tyty.com/doc/web/#/282/12890
export const getSubjectTryStatus = (params) => {
  return request({
    url: `BUSINESS/business/getSubjectTryStatus`,
    method: 'get',
    params
  })
}

// 获取服务器列表
export const getServiceList = () => {
  return request({
    url: `OSSDCP/inst/Servers`,
    method: 'get',
    headers: {
      domain: baseStore.baseUrl.ManagementServiceUrl
    },
  })
}

// 检查开通科目状态（新）-https://kf.51tyty.com/doc/web/#/282/12927
export const checkSubjectStatus = (params) => {
  return request({
    url: `BUSINESS/business/checkSubjectStatus`,
    method: 'get',
    params
  })
}

// 获取科目付款信息（新）-https://kf.51tyty.com/doc/web/#/282/12926
export const getSubjectPayInfo = (params) => {
  return request({
    url: `BUSINESS/business/getSubjectInfo`,
    method: 'get',
    params
  })
}

// 获取学科开通记录 - https://kf.51tyty.com/doc/web/#/282/12980
export const getSubjectRecordsList = (params) => {
  return request({
    url: `BUSINESS/subject/getRecordsList`,
    method: 'get',
    params
  })
}

// 延长试用/启用机构接口 - https://kf.51tyty.com/doc/web/#/282/12984
export const setDelaySubject = (data) => {
  return request({
    url: `BUSINESS/subject/delaySubject`,
    method: 'post',
    data
  })
}

// 获取支付状态 - https://kf.51tyty.com/doc/web/#/282/12985
export const watchPayStatus = (data) => {
  return request({
    url: `BUSINESS/business/watchPayStatus`,
    method: 'post',
    data
  })
}

// 获取账号密码
export const getInstPassword = (params) => {
  return request({
    url: `BUSINESS/business/instPassword`,
    method: 'get',
    params
  })
}

// 获取机构配置信息
export const instConfigData = (params) => {
  return request({
    url: `BUSINESS/business/instConfigData`,
    method: 'get',
    params
  })
}

export default {
  getCampusList,
  getCampusAccount,
  getSubjectList,
  getAllSubjectList,
  directlyCreateSubject,
  createSubject,
  deleteSubject,
  createCampus,
  directlyCreateCampus,
  getBusinessInfo,
  editCampus,
  editSubjectNickname,
  deleteCampus,
  switchInst,
  getSubjectTryStatus,
  getServiceList,
  checkSubjectStatus,
  getSubjectPayInfo,
  getSubjectRecordsList,
  setDelaySubject,
  watchPayStatus,
  getInstPassword,
  instConfigData,
}